<template>
  <div class="full">
    <vue-jitsi-meet
      ref="jitsiRef"
      domain="vc.mobilon.ru"
      :options="jitsiOptions"
    >
    </vue-jitsi-meet>
  </div>
</template>

<script>
import { JitsiMeet } from '@mycure/vue-jitsi-meet';
import delay from 'delay';

// переменная roomName зашита в шаблоне

export default {
  components: {
    VueJitsiMeet: JitsiMeet,
  },
  computed: {
    jitsiOptions () {
      return {
        width: '100%',
        height: '100%',
        roomName: roomName,
        noSSL: false,
        configOverwrite: {
          enableNoisyMicDetection: false,
          fileRecordingsEnabled: true,
        },
        interfaceConfigOverwrite: {
          SHOW_JITSI_WATERMARK: false,
          SHOW_WATERMARK_FOR_GUESTS: false,
          SHOW_CHROME_EXTENSION_BANNER: false
        },
        onload: this.onIFrameLoad
      };
    },
  },
  methods: {
    async onIFrameLoad () {
      await delay(5 * 1000);
      console.log('start record');
      this.$refs.jitsiRef.executeCommand('startRecording', {
        mode: 'file', //recording mode, either `local`, `file` or `stream`.
        //onlySelf: boolean,  //Whether to only record the local streams. Only applies to `local` recording mode.
        //shouldShare: boolean, //whether the recording should be shared with the participants or not. Only applies to certain jitsi meet deploys.
        //rtmpStreamKey: string, //the RTMP stream key.
        //rtmpBroadcastID: string, //the RTMP broadcast ID.
        //youtubeStreamKey: string, //the youtube stream key.
        //youtubeBroadcastID: string //the youtube broacast ID.
      });
    },
  },
};
</script>

<style>
  .full {
    height: 100vh;
  }
  iframe {
    overflow: hidden;
  }
</style>
